<ion-header>
  <ion-toolbar color="primary">
    <ion-title>Záradék-sablonok és az 1. melléklet</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="bezar()" fill="solid" color="light" shape="round">Bezár</ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <ion-progress-bar type="indeterminate" *ngIf="betolt"></ion-progress-bar>
  <ion-note *ngIf="hiba" color="danger" style="display:block;margin-bottom:10px">{{ hiba }}</ion-note>

  <ng-container *ngIf="adat">
    <p style="margin:0 0 8px;line-height:1.5">
      {{ adat.jogszabaly }} – {{ adat.melleklet }}. Az iskola által alkalmazható záradékokat ez a melléklet tartalmazza
      (112. § (4)). A lista az njt.hu hatályos szövegéből készült ({{ adat.lekerve }}).
    </p>

    <div style="display:flex;flex-wrap:wrap;gap:4px;margin-bottom:8px">
      <ion-chip color="medium" [outline]="true">Mellékleti záradék: {{ adat.osszesites.mellekleti }}</ion-chip>
      <ion-chip color="success">Van sablon: {{ adat.osszesites.van }}</ion-chip>
      <ion-chip [color]="adat.osszesites.hianyzik ? 'danger' : 'medium'" [outline]="!adat.osszesites.hianyzik">Nincs sablon: {{ adat.osszesites.hianyzik }}</ion-chip>
      <ion-chip color="warning" *ngIf="adat.osszesites.inaktiv">Csak inaktív: {{ adat.osszesites.inaktiv }}</ion-chip>
      <ion-chip color="warning" *ngIf="adat.osszesites.szoveg_elter">Eltérő szöveg: {{ adat.osszesites.szoveg_elter }}</ion-chip>
      <ion-chip [color]="adat.osszesites.ismeretlen_kod ? 'danger' : 'medium'" [outline]="!adat.osszesites.ismeretlen_kod">Nem létező kódra hivatkozó sablon: {{ adat.osszesites.ismeretlen_kod }}</ion-chip>
      <ion-chip color="medium" [outline]="true">Kód nélküli (saját) sablon: {{ adat.osszesites.kod_nelkuli_sablon }}</ion-chip>
    </div>

    <!-- A mellékletben nem létező kódra hivatkozó sablonok (elírt vagy megszűnt kód). -->
    <ng-container *ngIf="adat.ismeretlen_kod.length">
      <h3 style="margin:14px 0 4px">Nem létező mellékleti kódra hivatkozó sablonok</h3>
      <ion-list lines="full">
        <ion-item *ngFor="let s of adat.ismeretlen_kod">
          <ion-badge slot="start" color="danger">{{ s.melleklet_kod }}</ion-badge>
          <ion-label class="ion-text-wrap">
            <p>{{ s.szoveg }}</p>
            <p *ngIf="!s.aktiv" style="font-size:.8rem">(inaktív sablon)</p>
          </ion-label>
        </ion-item>
      </ion-list>
    </ng-container>

    <ion-segment [(ngModel)]="szuro" style="max-width:420px;margin:12px 0 6px">
      <ion-segment-button value="gond"><ion-label>Teendő</ion-label></ion-segment-button>
      <ion-segment-button value="mind"><ion-label>Mind a {{ adat.osszesites.mellekleti }}</ion-label></ion-segment-button>
    </ion-segment>

    <ion-note *ngIf="!lathatoTetelek.length" color="success" style="display:block;padding:8px 2px">
      Minden mellékleti záradékhoz van aktív sablon, a mellékletivel egyező szöveggel.
    </ion-note>

    <ion-list lines="full">
      <ion-item *ngFor="let t of lathatoTetelek">
        <ion-badge slot="start" color="dark">{{ t.kod }}</ion-badge>
        <ion-label class="ion-text-wrap">
          <p style="color:var(--ion-text-color)">{{ t.szoveg }}</p>
          <p style="font-size:.8rem">
            <ng-container *ngIf="t.dokumentumok_jelolese">Dokumentumok: {{ t.dokumentumok_jelolese }}</ng-container>
            <ng-container *ngIf="t.tipus === 'kollegium'"> – kollégiumi záradék</ng-container>
            <ng-container *ngIf="t.megjegyzes"> – {{ t.megjegyzes }}</ng-container>
          </p>
        </ion-label>
        <ion-badge slot="end" [color]="allapotSzin(t)" style="white-space:nowrap">{{ allapotSzoveg(t) }}</ion-badge>
      </ion-item>
    </ion-list>

    <p *ngIf="adat.kihagyott.length" style="font-size:.8rem;color:var(--ion-color-medium);margin-top:10px">
      Kihagyva: <ng-container *ngFor="let k of adat.kihagyott; let utolso = last">{{ k.sorszam }}. sor ({{ k.ok }}){{ utolso ? '' : '; ' }}</ng-container>
    </p>
  </ng-container>
</ion-content>
